import React from 'react'
import './styles.scss'
import { Button, Spin } from 'antd'

export default ({on_launch, loading}) =>
{
  const windows_link = 'https://file-catalyst-assets.s3.amazonaws.com/agent/Windows/install_fc_transferagent.exe'
  const mac_link     = 'https://file-catalyst-assets.s3.amazonaws.com/agent/MacOSX/FileCatalystTransferAgent.pkg'
  const linux_link   = 'https://file-catalyst-assets.s3.amazonaws.com/agent/Linux/fc_transferagent.tar.gz'

  const link = () => {
    if(navigator.platform.indexOf('Win') !== -1){
      return windows_link
    } else if(navigator.platform.indexOf('Mac') !== -1){
       return mac_link
    }
    return linux_link
  }

  return (
    <div className='launcher'>
      <p>Download the CloudFlyer Transfer agent.</p>
      <div>
        {
          loading ? <Spin size='small' style={{margin: 'auto'}} /> :
            [
              <Button key={'Download'}>
                <a href={link()}>Download</a>
              </Button>,
              <Button key={'Launch'} loading={loading} onClick={on_launch}>Launch!</Button>
            ]
        }
      </div>
    </div>
  )
}

